import { Link, useLocation } from "react-router-dom"
import { NarrowLayout } from "source/Layout"
import { PostDonateStatus } from "../donation_form/components/PostDonateStatus"

export function DonationFailure() {
  const {
    state: { errorMessage },
  } = useLocation()

  return (
    <NarrowLayout>
      <PostDonateStatus
        status="failure"
        heading="Donation failed"
        message={errorMessage}
        actions={
          <Link to="/giving" className="btn primary-btn">
            Try again
          </Link>
        }
      />
    </NarrowLayout>
  )
}
